import { NgModule } from '@angular/core';
import { ExtensionToolTipDisplayPipe } from './extension-tool-tip-display.pipe';

@NgModule({
   declarations: [ExtensionToolTipDisplayPipe],
   exports: [ExtensionToolTipDisplayPipe],
})
export class ExtensionToolTipDisplayPipeModule {}
